import React, { useState } from "react";
import "../../styles/General.css";
import { Form, Button, Container, Card, Alert } from "react-bootstrap";
import { supabase } from "../../config/Supabase";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    setShowAlert(false);

    try {
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(
        email,
        { redirectTo: `${window.location.origin}/login` }
      );
      if (resetError) throw resetError;
      setMessage("Password reset email sent. Check your inbox.");
      setShowAlert(true);
    } catch (err) {
      setError(
        "Failed to send password reset email. Please check if the email is correct."
      );
      setShowAlert(true);
    }
  };

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      <div className="w-100" style={{ maxWidth: "400px", paddingTop: "60px" }}>
        <Card className="shadow no-border-card" style={{ height: "500px" }}>
          <Card.Body>
            <Card.Title className="login-card-title">Reset Password</Card.Title>
            <Form onSubmit={handleSubmit}>
              <Form.Group
                controlId="formBasicEmail"
                style={{ paddingTop: "30px" }}
              >
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
              {showAlert && error && (
                <Alert variant="danger" className="mt-3">
                  {error}
                </Alert>
              )}
              {showAlert && message && (
                <Alert variant="success" className="mt-3">
                  {message}
                </Alert>
              )}
              <div style={{ paddingTop: "50px" }}>
                <Button
                  variant="primary"
                  type="submit"
                  className="login-btn w-100 mt-3"
                >
                  Reset Password
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default ForgotPassword;
